import { emailConstants } from "../constants/emailConstants";

const initialState = {
  sending: false,
  updating: false,
  updated: false,
  error: "",
  updatedsmtp: {},
  smtpDetails: {},
  deletedSmtp: {},
  deletedDetails: false,
  deletingDetails: false,
  receivedEmailTempelateDetails: false,
  receivingEmailTempelateDetails: false,
  emailTempelateDetails: {},
  receivedEmailTempelateList: false,
  receivingEmailTempelateList: false,
  emailTempelatesList: {},
  updatingEmailTempelateDetails: false,
  updatedEmailTempelateDetails: false,
  updateEmailTempelateResponse: {},
  updatemailResponse: {},
    mailResponse: {},

};

export default function emailReducer(state = initialState, action) {
  switch (action.type) {
    case emailConstants.ADD_EMAIL_REQUEST:
      return {
        ...state,
        updating: true,
        updated: false,
      };
    case emailConstants.ADD_EMAIL_SUCCESS:
      return {
        ...state,
        updating: false,
        updated: true,
        updatedsmtp: action.data,
        error: "",
      };
    case emailConstants.ADD_EMAIL_FAILURE:
      return {
        ...state,
        updated: false,
        updating: false,
        error: action.error,
      };
    case emailConstants.GET_EMAIL_DETAILS_REQUEST:
      return {
        ...state,
        receivedDetails: false,
        receivingDetails: true,
      };
    case emailConstants.GET_EMAIL_DETAILS_SUCCESS:
      return {
        ...state,
        receivedDetails: true,
        receivingDetails: false,
        smtpDetails: action.data.data,
      };
    case emailConstants.GET_EMAIL_DETAILS_FAILURE:
      return {
        ...state,
        receivingDetails: false,
        receivedDetails: false,
        error: action.error,
      };
    case emailConstants.DELETE_SMTP_REQUEST:
      return {
        ...state,
        deletedDetails: false,
        deletingDetails: true,
        error: "",
      };
    case emailConstants.DELETE_SMTP_SUCCESS:
      return {
        ...state,
        deletedDetails: true,
        deletingDetails: false,
        deletedSmtp: action.data,
        smtpDetails: {},
        error: "",
      };
    case emailConstants.DELETE_SMTP_FAILURE:
      return {
        ...state,
        deletedDetails: false,
        deletingDetails: false,
        error: action.error,
      };
    case emailConstants.GET_EMAIL_TEMPELATE_REQUEST:
      return {
        ...state,
        receivedEmailTempelateList: false,
        receivingEmailTempelateList: true,
      };
    case emailConstants.GET_EMAIL_TEMPELATE_SUCCESS:
      return {
        ...state,
        receivedEmailTempelateList: true,
        receivingEmailTempelateList: false,
        emailTempelatesList: action.data.data,
      };
    case emailConstants.GET_EMAIL_TEMPELATE_FAILURE:
      return {
        ...state,
        receivedEmailTempelateList: false,
        receivingEmailTempelateList: false,
        error: action.error,
      };
    case emailConstants.GET_EMAIL_TEMPELATE_DETAILS_REQUEST:
      return {
        ...state,
        receivedEmailTempelateDetails: false,
        receivingEmailTempelateDetails: true,
      };
    case emailConstants.GET_EMAIL_TEMPELATE_DETAILS__SUCCESS:
      return {
        ...state,
        receivedEmailTempelateDetails: true,
        receivingEmailTempelateDetails: false,
        emailTempelateDetails: action.data.data,
      };
    case emailConstants.GET_EMAIL_TEMPELATE_DETAILS_FAILURE:
      return {
        ...state,
        receivedEmailTempelateDetails: false,
        receivingEmailTempelateDetails: false,
        error: action.error,
      };
    case emailConstants.UPDATE_EMAIL_TEMPELATE_DETAILS_REQUEST:
      return {
        ...state,
        updatingEmailTempelateDetails: false,
        updatedEmailTempelateDetails: true,
      };
    case emailConstants.UPDATE_EMAIL_TEMPELATE_DETAILS__SUCCESS:
      return {
        ...state,
        updatingEmailTempelateDetails: true,
        updatedEmailTempelateDetails: false,
        updateEmailTempelateResponse: action.data,
      };
    case emailConstants.UPDATE_EMAIL_TEMPELATE_DETAILS_FAILURE:
      return {
        ...state,
        updatingEmailTempelateDetails: false,
        updatedEmailTempelateDetails: false,
        error: action.error,
      };
    case emailConstants.TEST_MAIL_REQUEST:
      return {
        ...state,
        sending: true,
      };
    case emailConstants.TEST_MAIL_SUCCESS:
      //console.log(action.data);
      return {
        ...state,
        updatemailResponse: action.data,
      };

    case emailConstants.TEST_MAIL_FAILURE:
      return {
        ...state,
        error: action.error,
      };
       case emailConstants.TEST_EMAIL_REQUEST:
      return {
        ...state,
        sending: true,
      };
    case emailConstants.TEST_EMAIL_SUCCESS:
    
      return {
        ...state,
        mailResponse: action.data,
      };

    case emailConstants.TEST_EMAIL_FAILURE:
      return {
        ...state,
        error: action.error,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/redux/reducers/emailReducer.js